import Header from "./header/header";
import Footer from "./footer/footer";
import NavBar from "./nav/nav-bar";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import WebPull from "./webservice/web-pull";
import { Link } from "react-router-dom";
import Service from "./webservice/http";
import ProgressBar from "./progress-bar";
import fetchProgress from "fetch-progress";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import PulseLoader from "react-spinners/PulseLoader";
import { BiError, BiCommentAdd, BiTaskX } from "react-icons/bi";
import { RiSignalWifiErrorFill, RiDeleteRow } from "react-icons/ri";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import Filter from "./filter";
import { FaFilter } from "react-icons/fa";
import Pagination from "./components/pagination";
import Select from "react-select";
import config from "./config";
import { storage } from "./utils/storage";
import { debounce, set } from "lodash";
import uploadIcon from "./assets/images/upload.svg";
import PhoneInput from "react-phone-input-2";
import arrowDown from "./assets/images/arrow-down-black.svg";
import arrowScroll from "./assets/images/arrow-scroll.svg";
const CallList = () => {
  const history = useHistory();
  const location = useLocation();
  const clientName = storage.getItem("client_name");
  const useCase = storage.getItem("usecase");
  const intervalRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState(null);
  //const { data: callList, error, isPending } = WebPull('https://fb.dataklout.com/api/call/call_list/')
  // console.log(config);
  const [callList, setCallList] = useState(null);
  const [callCategory, setCallCategory] = useState("");

  const [error, setError] = useState(null);
  const [isPending, setisPending] = useState(true);
  // const [audiotype, setAudiotype] = useState("");
  const [pageno, setpageno] = useState("");
  const [totalpage, setTotalpage] = useState([]);
  const [totalresult, setTotalresult] = useState("");
  const [data, setdata] = useState("");
  // const [hasnext, setHasnext] = useState("")
  const [maxpage, settMaxpage] = useState("");
  const [bulkupload, setBulkupload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [refreshTime, setRefreshTime] = useState(20000);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState(() => {
    // If navigated from home Collections table, pre-apply date filters immediately
    // so the very first fetchCallList call uses them (avoids a double-fetch race).
    const navState =
      (window.history.state && window.history.state.usr) ||
      (window.history.state && window.history.state.state) ||
      {};
    if (navState.from_date || navState.to_date) {
      const pre = {};
      if (navState.from_date) pre.from_date = navState.from_date;
      if (navState.to_date) pre.to_date = navState.to_date;
      return pre;
    }
    return {};
  });
  const [filterType, setFilterType] = useState("Organization");
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [isKnowMoreOpen, setIsKnowMoreOpen] = useState(false);
  const [bulkLoader, setBulkLoader] = useState(false);
  const [newcustomer, setNewcustomer] = useState(false);

  // conatct section

  const [contactID, setContactID] = useState("");
  const [salutation, setSalutation] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [suffix, setSuffix] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [referenceID, setReferenceID] = useState("");
  const [relation, setRelation] = useState("");
  const [contactList, setContactList] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [isStorePending, setIsStorePending] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [dublicatenumber, setDublicatenumber] = useState("");
  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("tab") || "processed";
  });
  const [failedSubTab, setFailedSubTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("subtab") || "deviance";
  });
  const [devianceCalls, setDevianceCalls] = useState(null);
  const [isDeviancePending, setIsDeviancePending] = useState(false);
  const [devianceCurrentPage, setDevianceCurrentPage] = useState(1);
  const [devianceTotalPages, setDevianceTotalPages] = useState([]);
  const [devianceTotalResult, setDevianceTotalResult] = useState("");
  const [expandedStates, setExpandedStates] = useState({});

  const toggleExpand = (index) => {
    setExpandedStates((prev) => ({
      ...prev,
      [index]: !prev[index] || false,
    }));
  };

  function fetchContactList() {
    return services.get("api/customer/contact/").then((res) => {
      if (res === "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        try {
          if (res.code === "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setContactList(res?.data);
          setError(null);
          return res?.data;
        } catch (e) {
          setError(e);
        }
      }
    });
  }

  useEffect(() => {
    fetchContactList();
  }, []);

  useEffect(() => {
    const navState = location.state || {};
    if (navState.from_date || navState.to_date) {
      setFilters((prev) => {
        if (!prev.from_date && !prev.to_date) {
          const pre = {};
          if (navState.from_date) pre.from_date = navState.from_date;
          if (navState.to_date) pre.to_date = navState.to_date;
          return pre;
        }
        return prev;
      });
    }
  }, []);

  const addNewContact = () => {
    setErrorText("");
    if (
      salutation === "" ||
      firstName === "" ||
      lastName === "" ||
      suffix === "" ||
      contactNumber === ""
    ) {
      setErrorText(
        "Salutation, First Name, Last Name, Suffix and Contact Number are mandatory fields",
      );
      return;
    }
    if (
      contactList.some((item) => item.contact_number.includes(contactNumber))
    ) {
      setErrorText("This contact number already exists");
      return;
    }
    if (referenceID !== "") {
      if (relation === "") {
        setErrorText("Please Mention relation");
        return;
      }
    }

    setShowConfirmation(true);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearch(value.toLowerCase());
    }, 500),
    [],
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);
    debouncedSearch(value);
  };

  /**
   * Fetch Call List data
   */

  // console.log(Object.keys(filters).length);

  async function fetchCallList() {
    setError(null);
    setisPending(true);

    const params = new URLSearchParams();
    if (currentPage > 1) {
      params.append("page", currentPage);
    }
    if (search) {
      params.append("search", search);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "" && value != null) {
        if (Array.isArray(value)) {
          value.forEach((v) => params.append(key, v));
        } else {
          params.append(key, value);
        }
      }
    });

    const baseUrl = "api/call/call_list/";

    const queryString = params.toString().replace(/\+/g, "%20");
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    try {
      const res = await services.get(url);

      setisPending(false);

      if (res === "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else if (res.code === "token_not_valid") {
        storage.clear();
        history.push("/login");
      } else {
        setCallList(res.data);
        setTotalpage(res.pagination.page_numbers);
        setTotalresult(res.pagination.total_results);
        settMaxpage(res.pagination.total_pages);
        setdata(res);
        setError(null);
      }
    } catch (e) {
      setError(e.message);
      setisPending(false);
    }
  }

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    const params = new URLSearchParams(location.search);
    params.set("page", pageNumber);
    history.push(`/call-list?${params.toString().replace(/\+/g, "%20")}`);
  };

  const handleDeviancePageClick = (pageNumber) => {
    setDevianceCurrentPage(pageNumber);
  };

  // Persist active tab in URL so browser back button restores the correct tab
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    if (tab === "failed" && !params.has("subtab")) {
      params.set("subtab", "deviance");
      setFailedSubTab("deviance");
    } else if (tab !== "failed") {
      params.delete("subtab");
    }
    params.delete("page");
    history.replace(`/call-list?${params.toString().replace(/\+/g, "%20")}`);
  };

  const handleSubTabChange = (subtab) => {
    setFailedSubTab(subtab);
    const params = new URLSearchParams(location.search);
    params.set("subtab", subtab);
    history.replace(`/call-list?${params.toString().replace(/\+/g, "%20")}`);
  };

  /**
   * Handle refresh call list in each specific interval
   *
   * This is required to display audio processing progress
   */

  useEffect(() => {
    fetchCallList();
  }, [search, currentPage, filters, filterType]);

  // Sync tab state from URL when user navigates back/forward
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab") || "processed";
    const subtab = params.get("subtab") || "deviance";
    setActiveTab((prev) => (prev !== tab ? tab : prev));
    setFailedSubTab((prev) => (prev !== subtab ? subtab : prev));
  }, [location.search]);

  // Track whether any calls are still uploading via a ref so we can
  // start / stop the polling interval without causing an infinite loop.
  const isUploadingRef = useRef(false);

  useEffect(() => {
    isUploadingRef.current =
      Array.isArray(callList) &&
      callList.some((item) => Number(item._progress) < 100);
  }, [callList]);

  useEffect(() => {
    // Only start the polling interval when there are uploading items
    if (!isUploadingRef.current) return;

    const id = setInterval(() => {
      // Re-check before each fetch in case uploads finished
      if (isUploadingRef.current) {
        fetchCallList();
      }
    }, refreshTime);

    return () => clearInterval(id);
  }, [refreshTime]);

  // console.log(callList?.some((item) => item._progress < 100));

  const [showCallModal, setShowCallModal] = useState(false);
  const toggolCallModal = () => {
    setShowCallModal(!showCallModal);
  };

  const [supportingInfo, setSupportingInfo] = useState();
  const [supportingInfoPending, setSupportingInfoPending] = useState();
  const [supportingInfoError, setSupportingInfoError] = useState();

  const services = useMemo(() => new Service(), []);

  const [uploadFile, setUploadFile] = useState(null);
  const [callType, setCallType] = useState("");
  const [product, setProduct] = useState("");
  const [languageCode, setLanguageCode] = useState("");
  const [customerID, setCustomerID] = useState("");
  // const [callCategory, setCallCategory] = useState("");

  //const [uploadData, setUploadData] = useState(null);
  const [uploadPending, setUploadPending] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [callUploadProgress, setCallUploadProgress] = useState(0);

  const [callUploadSucess, setCallUploadSucess] = useState(false);

  // console.log("hello", callType, product, languageCode, customerID);

  // console.log(callType);
  /**
   * Upload call recording file with other required details to process
   *
   * axios is being used here to display upload progress
   */

  const [selectedfile, setSelectedfile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file && file.type === "text/csv") {
      setSelectedfile(file);
      setSelectedFileName(file.name);
      // console.log("Selected file:", file);
    } else {
      alert("Please select a valid CSV file.");
      setSelectedfile(null);
      setSelectedFileName("");
    }
  };
  const handleClearFile = (e) => {
    e.stopPropagation();
    setSelectedfile(null);
    setSelectedFileName("");
  };
  // console.log("hsyhsyy", selectedfile);

  const uploadCallRecording = () => {
    setCallUploadProgress(0);
    setUploadError(null);
    setSupportingInfoError("");

    if (callType === "") {
      setSupportingInfoError("Please Select Call Type");
      return;
    }

    if (product === "") {
      setSupportingInfoError("Please Select one product");
      return;
    }

    if (languageCode === "") {
      setSupportingInfoError("Please Select one language");
      return;
    }

    if (customerID === "") {
      setSupportingInfoError("Please Select one customer");
      return;
    }

    if (uploadFile === null) {
      setSupportingInfoError("Please select one audio recording file");
      return;
    }
    if (callCategory === "") {
      setSupportingInfoError("Please select Call Category");
      return;
    }
    // if (audiotype !== "wav") {
    //   setSupportingInfoError("Please check the call recording format i.e wav");
    //   return;
    // }

    setUploadPending(true);
    var url = services.domain + "/api/call/new_call/";

    let formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("call_type", callType);
    formData.append("product", product);
    formData.append("language_code", languageCode);
    formData.append("customer_id", customerID);
    formData.append("internal", callCategory);
    // console.log("File size :" + uploadFile.size);

    axios
      .request({
        method: "post",
        url: url,
        headers: {
          Authorization: "Bearer " + storage.getItem("access_token"),
        },
        data: formData,
        onUploadProgress: (p) => {
          setCallUploadProgress(Math.round((p.loaded * 100) / uploadFile.size));
        },
      })
      .then((data) => {
        setUploadPending(false);
        setUploadError(null);
        // console.log(data.data.message);
        if (data.data.message === "success") {
          setUploadFile(null);
          setCallType("");
          setProduct("");
          setLanguageCode("");
          setCustomerID();
          setShowCallModal(false);
          fetchCallList();
          NotificationManager.success(
            "Success",
            "Your call uploaded successfully ",
          );
          setCallUploadSucess(true);
          setCurrentPage(1);
          history.push(`/call-list?page=${1}`);
        } else {
          setUploadPending(false);
          setUploadError(data.message);
        }
      });
  };

  /**
   * Fetch new call supporting information option data which are required to process a call
   */
  function fetchSupportingInfo() {
    return services.get("api/call/new_call/").then((res) => {
      setSupportingInfoPending(false);
      if (res === "TypeError: Failed to fetch") {
        setSupportingInfoError("Failed to Fetch");
      } else {
        if (res.code === "token_not_valid") {
          storage.clear();
          history.push("/login");
        }

        setSupportingInfo(res);
        setSupportingInfoError(null);
      }
    });
  }

  useEffect(() => {
    fetchSupportingInfo();
  }, [currentPage]);

  // console.log(audiotype);

  /**
   * Navigate to call insight
   * @param {*} callId Call ID
   * @param {*} intent Intent Value
   */
  function openCallInsight(callId, intent) {
    if (intent !== 0) {
      history.push(`/call/${callId}/call-insight`);
    }
  }

  function openComplainstInsight(callId, intent) {
    if (intent !== 0) {
      history.push(`/ticket/${callId}/complaints-insight`);
    }
  }

  /**
   * Remove processing failed calls
   * @param {*} callId Failed call ID
   */
  function removeFailedItem(callId) {
    services.post(`api/call/${callId}/mark_failed/`).then((res) => {
      if (res == "TypeError: Failed to fetch") {
        NotificationManager.error("Error", "Connection Error");
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        if (res.message === "success") {
          NotificationManager.success("Success", "Removed item");
          fetchCallList();
        }
      }
    });
  }

  const [sideBarWidth, setSideBarWidth] = useState(0);

  // console.log(usecase);
  /**\
   * Change side filter bar width
   */
  const changeSideBarWidth = () => {
    if (sideBarWidth == 570) {
      setSideBarWidth(0);
      setIsFilterOpen(false);
    } else {
      setSideBarWidth(570);
      setIsFilterOpen(true);
    }
  };

  // console.log("search", search);

  // const page = [1, 2, 3, 4, 5];

  // const [xlsxfile, setxlsxFile] = useState(null);
  // const handleFileChange = (event) => {
  //   setxlsxFile(event.target.files[0]);
  // };

  // const handleUpload = () => {
  //   var url = "https://fb.dataklout.com/api/call/bulk_call/";
  //   let formData = new FormData();
  //   formData.append("file", xlsxfile);
  //   axios
  //     .request({
  //       method: "post",
  //       url: url,
  //       headers: {
  //         Authorization: "Bearer " + storage.getItem("access_token"),
  //       },
  //       data: formData,
  //     })
  //     .then((data) => {
  //       setUploadPending(false);
  //       setUploadError(null);
  //       setShowCallModal(false);

  //       // console.log(data.data.message);
  //       if (data.data.message === "success") {
  //         NotificationManager.success(
  //           "Success",
  //           "Your call uploaded successfully"
  //         );
  //         setCallUploadSucess(true);
  //       } else {
  //         setUploadPending(false);
  //         setUploadError(data.message);
  //       }
  //     });
  // };

  // const handleDownload = () => {
  //   const sampleFilePath = process.env.PUBLIC_URL + "/assets/Sample file.xlsx";
  //   const link = document.createElement("a");
  //   link.setAttribute("href", sampleFilePath);
  //   link.setAttribute("download", "Sample file.xlsx");
  //   document.body.appendChild(link);
  //   link.click();
  // };

  // useEffect(() => {
  //   if (uploadFile) {
  //     setAudiotype(uploadFile.name.split(".").pop());
  //   }
  // }, [uploadFile]);

  // console.log("nono", audiotype);

  // Bulk upload

  const [bulkdata, setBulkdata] = useState({
    call_type: "",
    product: "",
    language_code: "",
    customer_id: "",
    files: null,
  });

  const [addBulkCall, setAddBulkCall] = useState([]);
  const [callName, setCallName] = useState([]);
  const [emptycall, setEmptycall] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [delcall, setDelcall] = useState("");

  const handelBulkChange = function (key, value) {
    setEmptycall(false);
    setSupportingInfoError("");
    setBulkdata({ ...bulkdata, [key]: value });
  };

  // console.log("file format ", bulkdata.files);
  // console.log(callName);

  const addCall = function (e) {
    e.preventDefault();
    if (bulkdata?.call_type === "") {
      setSupportingInfoError("Please Select Call Type");
      return;
    }

    if (bulkdata?.product === "") {
      setSupportingInfoError("Please Select one product");
      return;
    }

    if (bulkdata?.language_code === "") {
      setSupportingInfoError("Please Select one language");
      return;
    }

    if (bulkdata?.customer_id === "") {
      setSupportingInfoError("Please Select one customer");
      return;
    }

    if (bulkdata?.files === null) {
      setSupportingInfoError("Please select one audio recording file");
      return;
    }
    if (bulkdata?.files.name.split(".").pop() !== "wav") {
      setSupportingInfoError("Please check the call recording format i.e wav");
      return;
    }

    // console.log(bulkdata);
    // the if block here can be eliminated but i m just being double sure about the call data by putting a checker again  setting the call error info

    if (
      bulkdata.call_type &&
      bulkdata.product &&
      bulkdata.language_code &&
      bulkdata.customer_id &&
      bulkdata.files
    ) {
      setAddBulkCall((prev) => [...prev, bulkdata]);
      setCallName((prev) => [...prev, bulkdata.files]);
      setBulkdata({
        call_type: "",
        product: "",
        language_code: "",
        customer_id: "",
        files: null,
      });

      setFileInputKey((prevKey) => prevKey + 1);
    } else {
      setEmptycall(true);
    }
  };

  // console.log("yyyyyyyyyyy", addBulkCall);

  const [totalDuration, setTotalDuration] = useState(0);

  useEffect(() => {
    const calculateTotalDuration = () => {
      const durations = [];
      let filesCount = 0;

      // Flatten all files from all objects
      const allFiles = addBulkCall.flatMap((dataObject) => dataObject.files);

      allFiles.forEach((file) => {
        const audio = new Audio(URL.createObjectURL(file));

        audio.addEventListener("loadedmetadata", () => {
          durations.push(audio.duration);

          // Check if all files have been processed
          if (durations.length === allFiles.length) {
            // Sum durations
            const total = durations.reduce(
              (sum, duration) => sum + duration,
              0,
            );
            setTotalDuration(total);
          }
        });

        audio.addEventListener("error", () => {
          durations.push(0);

          if (durations.length === allFiles.length) {
            const total = durations.reduce(
              (sum, duration) => sum + duration,
              0,
            );
            setTotalDuration(total);
          }
        });
      });
    };

    calculateTotalDuration();
  }, [addBulkCall]);

  // console.log("ddddddddddd", totalDuration);

  const [durationerror, setDurationerror] = useState(false);

  const [estimatedTime, setEstimatedTime] = useState(0);
  const [bulkerrormessage, setBulkerrormessage] = useState("");

  const handleBulkUpload = () => {
    setBulkLoader(true);
    setUploadError(null); // clear any old error first

    if (!selectedfile) {
      setUploadError("No file selected.");
      setBulkLoader(false);
      return;
    }

    // Validate file type
    const validTypes = ["text/csv", "application/vnd.ms-excel"];
    const fileExtension = selectedfile.name.split(".").pop().toLowerCase();
    if (!validTypes.includes(selectedfile.type) || fileExtension !== "csv") {
      setUploadError("Please upload a valid .csv file.");
      setBulkLoader(false);
      return;
    }

    const url = `${config.API_BASE_URL}/api/call/bulk_calls_csv/`;
    const formData = new FormData();
    formData.append("file", selectedfile);

    axios
      .post(url, formData, {
        headers: {
          Authorization: "Bearer " + storage.getItem("access_token"),
        },
      })
      .then((response) => {
        setBulkLoader(false);
        setUploadError(null);
        setShowCallModal(false);
        setSelectedfile(null);
        setSelectedFileName(null);
        setBulkupload(false);
        fetchCallList();
        setEstimatedTime(response.data.estimated_time);
        setBulkerrormessage(response.data.message);

        console.log("here is the response", response);

        if (response.data.message.includes("Bulk upload completed")) {
          NotificationManager.success(
            "Success",
            "Your calls uploaded successfully",
          );
          setCallUploadSucess(true);
          history.push(`/call-list?page=${1}`);
          setAddBulkCall([]);
          setCallName([]);
        } else {
          setUploadError(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error uploading call:", error);

        const errMsg =
          error?.response?.data?.message ||
          error?.response?.data?.detail ||
          "An error occurred while uploading the call.";

        setBulkLoader(false);
        setUploadError(errMsg);

        NotificationManager.error("Upload Failed", errMsg);
      });
  };

  // Function to handle deletion of a call
  const handleDeleteCall = (index) => {
    setAddBulkCall((prevCalls) => prevCalls.filter((_, i) => i !== index));
  };
  // console.log("customer id", supportingInfo.customer);

  useEffect(() => {
    fetchCallList();
  }, [callUploadSucess]);

  useEffect(() => {
    if (isFilterOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isFilterOpen]);

  const handleFilterApply = (appliedFilters) => {
    setFilters(appliedFilters);
    // setCurrentPage(1);
    // history.push(`/call-list?page=1`);
    // fetchCallList();
  };
  useEffect(() => {
    // console.log("Filters updated:", filters);
  }, [filters]);

  const confirmAddNewContact = () => {
    setIsStorePending(true);
    var contactData = {
      id: contactID,
      salutation: salutation,
      first_name: firstName,
      middle_name: middleName,
      last_name: lastName,
      suffix: suffix,
      contact_number: contactNumber,
      reference: referenceID,
      reference_relation: relation,
    };

    services.post("api/customer/contact/", contactData).then((res) => {
      if (res == "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        if (res.message === "success") {
          NotificationManager.success("Success", "Contact Created");
          fetchContactList().then((updatedContactList) => {
            if (updatedContactList) {
              console.log(".........", updatedContactList);
              const newContact = updatedContactList.find(
                (contact) => contact?.contact_number === contactNumber,
              );

              if (newContact) {
                setCustomerID(newContact.id);
                console.log("New Contact ID:", newContact.id);
              } else {
                console.error(
                  "New contact not found in the updated contact list.",
                );
              }
            }
          });
          setContactID("");
          setSalutation("");
          setFirstName("");
          setLastName("");
          setMiddleName("");
          setSuffix("");
          setContactNumber("");
          setReferenceID("");
          setRelation("");
          setErrorText("");

          setShowConfirmation(false);
          setIsStorePending(false);
          setNewcustomer(false);
          fetchSupportingInfo();
        } else {
          console.error("Unexpected API response:", res);
          setIsStorePending(false);
        }
      }
    });
  };

  // console.log(contactList);

  // failed call upload

  // const failedCallList = async function () {
  //   try {
  //     const failedCalls = await services.get("api/call/bulk_record/");
  //     if (failedCalls.code === "token_not_valid") {
  //       storage.clear();
  //       history.push("/login");
  //     }
  //     // setCallList(failedCalls.data);
  //     // setTotalpage(failedCalls.pagination.page_numbers);
  //     // setTotalresult(failedCalls.pagination.total_results);
  //     // settMaxpage(failedCalls.pagination.total_pages);
  //     // setdata(failedCalls);
  //     // setError(null);
  //     console.log("failed calls", failedCalls);
  //     return failedCalls;
  //   } catch (e) {
  //     if (e === "TypeError: Failed to fetch") {
  //       setError("Connection Error");
  //     } else {
  //       setError(e);
  //     }
  //   }
  // };

  const [failedlist, setfailedlist] = useState("");

  const failedCallList = useCallback(
    async function () {
      return services.get("api/call/bulk_record/").then((res) => {
        if (res === "TypeError: Failed to fetch") {
          setSupportingInfoError("Failed to Fetch");
        } else {
          if (res.code === "token_not_valid") {
            storage.clear();
            history.push("/login");
          }

          setfailedlist(res?.data);
        }
      });
    },
    [history, services],
  );

  const fetchDevianceCalls = useCallback(
    async (page = 1) => {
      setIsDeviancePending(true);
      setError(null);
      try {
        const res = await services.get(
          `api/call_verification/deviance_analysis_calls/?page=${page}`,
        );
        setIsDeviancePending(false);
        if (res === "TypeError: Failed to fetch") {
          setError("Connection Error");
        } else if (res.code === "token_not_valid") {
          storage.clear();
          history.push("/login");
        } else {
          setDevianceCalls(res.data);
          setDevianceTotalPages(res.pagination.page_numbers);
          setDevianceTotalResult(res.pagination.total_results);
        }
      } catch (e) {
        setIsDeviancePending(false);
        setError(e.message);
      }
    },
    [history, services],
  );

  useEffect(() => {
    if (activeTab === "failed") {
      if (failedSubTab === "failed_upload") {
        failedCallList();
      } else {
        fetchDevianceCalls(devianceCurrentPage);
      }
    }
  }, [
    activeTab,
    failedSubTab,
    failedCallList,
    fetchDevianceCalls,
    devianceCurrentPage,
  ]);

  const token = storage.getItem("access_token");

  const handledownloadCSV = async function (batch_id) {
    try {
      const response = await axios.get(
        `${config.API_BASE_URL}/api/call/bulk_record/?download=${batch_id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
            // Accept: "text/csv",
          },
        },
      );

      const blob = response.data;

      const contentType = response.headers["content-type"];
      if (!contentType.includes("text/csv")) {
        console.warn("Unexpected Content-Type:", contentType);
      }

      const url = URL.createObjectURL(blob);

      const contentDisposition = response.headers["content-disposition"];
      let filename = "failed_calls.csv";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Clean up the temporary link and revoke the object URL
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the report:", error);
      console.error("Error stack:", error.stack);
      alert(
        "Failed to download the report. Please check the after sometime or contact support.",
      );
    }
  };

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />
      {activeTab === "processed" && (
        <button
          onClick={changeSideBarWidth}
          style={{
            position: "fixed",
            transition: ".5s",
            top: "30%",
            right: sideBarWidth,
            backgroundColor: "#F99E52",
            color: "white",
            // borderTopColor: "black",
            // borderWidth: "2px",
            // boxShadow: "6px 6px 3px #999",
            // paddingTop: "15px",
            // paddingLeft: "5px",
            // paddingRight: "5px",
            padding: "10px",
            height: "37px",
            zIndex: "2",
            borderRadius: "10px",
            marginRight: sideBarWidth === 0 ? "25px" : "8px",
          }}
        >
          <FaFilter size="20" />
        </button>
      )}
      <Filter
        key={filterResetKey}
        width={sideBarWidth}
        changeSideBarWidth={changeSideBarWidth}
        filterType="call-list"
        // filterHasChanged={filterHasChanged}
        onApplyFilter={handleFilterApply}
        onresetFilter={() => {
          // console.log("Before reset, filters:", filters);
          setFilters({});
          setSearch("");
          setSearchInput("");
          setCurrentPage(1);
        }}
      />
      {sideBarWidth == 570 && (
        <div className="backdrop" onClick={changeSideBarWidth}></div>
      )}

      <NotificationContainer />
      <div className="container-fluid">
        <div className="my-call">
          <div className="bg-white py-4 px-8 mb-4 h-36 flex items-center justify-between">
            <div>
              <div className="pannel-heading-icon">
                <i className="flaticon-incoming-call"></i>
              </div>
              <div className="pannel-heading-info">
                {useCase === "Complaints Management" ? (
                  <p>Tickets</p>
                ) : (
                  <p>Calls </p>
                )}
                {useCase === "Complaints Management" ? (
                  <div className="flex items-center gap-2">
                    <h3>My Tickets </h3>
                    <span className=" flex items-center gap-1">
                      ({" "}
                      {/* <i
                        className="fa fa-circle"
                        style={{ fontSize: "8px" }}
                        aria-hidden="true"
                      ></i>{" "} */}
                      {callList && callList.length} Items)
                    </span>
                  </div>
                ) : useCase === "Third Party Collection Agency" ? (
                  <div className="flex items-center gap-2">
                    <h3>My Calls : Collection</h3>
                    <span className=" flex items-center gap-1">
                      ({" "}
                      {/* <i
                        className="fa fa-circle"
                        style={{ fontSize: "8px" }}
                        aria-hidden="true"
                      ></i>{" "} */}
                      {callList && callList.length} Items)
                    </span>
                  </div>
                ) : (
                  <div className="flex items-center gap-2">
                    <h3>My Calls </h3>
                    <span className=" flex items-center gap-1">
                      ({" "}
                      {/* <i
                        className="fa fa-circle"
                        style={{ fontSize: "8px" }}
                        aria-hidden="true"
                      ></i>{" "} */}
                      {callList && callList.length} Items)
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="flex gap-4">
              <button
                className="py-2 px-10 rounded-lg call-list-btn hover:ease-in-out hover:text-white w-auto"
                onClick={toggolCallModal}
                // style={{ border: "1px solid gray" }}
              >
                {useCase === "Complaints Management" ? (
                  <span> Upload</span>
                ) : (
                  <span> New</span>
                )}
              </button>
              <button
                className="py-2 px-10 rounded-lg call-list-btn hover:ease-in-out hover:text-white"
                style={{
                  width:
                    useCase === "Third Party Collection Agency"
                      ? "130px"
                      : "120px",
                }}
                onClick={() => {
                  if (useCase === "Third Party Collection Agency") {
                    return;
                  } else {
                    history.push("/live-call");
                  }
                }}
              >
                {useCase === "Complaints Management" ? (
                  <span>Live Tickets</span>
                ) : (
                  <span>Live Call </span>
                )}
              </button>
            </div>
          </div>

          {Object.keys(filters).length > 0 && (
            <div
              style={{
                margin: "0 0 10px",
                padding: "8px 16px",
                backgroundColor: "#e8e3fa",
                borderLeft: "4px solid #271078",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "#271078",
                      marginRight: "4px",
                    }}
                  >
                    Filters ({Object.keys(filters).length}):
                  </span>

                  {(filters.from_date || filters.to_date) && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#f2effa",
                        border: "1px solid #dcd4f5",
                        borderRadius: "20px",
                        padding: "4px 6px 4px 16px",
                        color: "#271078",
                        fontSize: "13px",
                        fontWeight: "600",
                        gap: "8px",
                      }}
                    >
                      <span>Date Range</span>
                      <div style={{ display: "flex", gap: "4px" }}>
                        {filters.from_date && (
                          <span
                            style={{
                              backgroundColor: "#fff",
                              border: "1px solid #e0d9f8",
                              color: "#271078",
                              borderRadius: "16px",
                              padding: "3px 10px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          >
                            From: {filters.from_date}
                          </span>
                        )}
                        {filters.to_date && (
                          <span
                            style={{
                              backgroundColor: "#fff",
                              border: "1px solid #e0d9f8",
                              color: "#271078",
                              borderRadius: "16px",
                              padding: "3px 10px",
                              fontSize: "12px",
                              fontWeight: "700",
                            }}
                          >
                            To: {filters.to_date}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {(() => {
                    const formatLabel = (key) => {
                      const ACRONYMS = { lob: "LOB" };
                      const words = key.replace(/_/g, " ").split(" ");
                      return words
                        .map(
                          (w) =>
                            ACRONYMS[w.toLowerCase()] ||
                            w.charAt(0).toUpperCase() +
                              w.slice(1).toLowerCase(),
                        )
                        .join(" ");
                    };

                    // Groups map: group name → keys that belong to it
                    const groups = {
                      Roles: [
                        "lob_name",
                        "manager_name",
                        "team_lead_name",
                        "agent_name",
                      ],
                      DCA: ["dca_organization_name"],
                      "Call Details": ["collection_strategy"],
                    };

                    // Keys not in any group get their own individual pill
                    const groupedKeys = Object.values(groups).flat();
                    const ungroupedEntries = Object.entries(filters).filter(
                      ([k]) =>
                        !groupedKeys.includes(k) &&
                        k !== "from_date" &&
                        k !== "to_date",
                    );

                    return (
                      <>
                        {Object.entries(groups).map(([groupName, keys]) => {
                          const activeInGroup = keys.filter((k) => filters[k]);
                          if (activeInGroup.length === 0) return null;

                          // Strip group prefix to avoid repeating group name in sub-pills
                          // e.g. for "DCA" group, strip "dca_" so "dca_organization_name" → "organization_name" → "Organization"
                          const groupPrefix =
                            groupName.toLowerCase().replace(/ /g, "_") + "_";

                          return (
                            <div
                              key={groupName}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#f2effa",
                                border: "1px solid #dcd4f5",
                                borderRadius: "20px",
                                padding: "4px 6px 4px 16px",
                                color: "#271078",
                                fontSize: "13px",
                                fontWeight: "600",
                                gap: "8px",
                              }}
                            >
                              <span>{groupName}</span>
                              <div style={{ display: "flex", gap: "4px" }}>
                                {activeInGroup.map((k) => {
                                  // Strip trailing "_name" suffix for cleaner labels, then strip group prefix
                                  let displayKey = k.endsWith("_name")
                                    ? k.slice(0, -5)
                                    : k;
                                  if (displayKey.startsWith(groupPrefix)) {
                                    displayKey = displayKey.slice(
                                      groupPrefix.length,
                                    );
                                  }
                                  return (
                                    <span
                                      key={k}
                                      style={{
                                        backgroundColor: "#fff",
                                        border: "1px solid #e0d9f8",
                                        color: "#271078",
                                        borderRadius: "16px",
                                        padding: "3px 10px",
                                        fontSize: "12px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      {formatLabel(displayKey)}: {filters[k]}
                                    </span>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}

                        {/* Render any remaining keys not in a group as individual pills */}
                        {ungroupedEntries.map(([k, v]) => (
                          <div
                            key={k}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              backgroundColor: "#f2effa",
                              border: "1px solid #dcd4f5",
                              borderRadius: "20px",
                              padding: "4px 16px",
                              color: "#271078",
                              fontSize: "13px",
                              fontWeight: "600",
                              gap: "6px",
                            }}
                          >
                            <span>{formatLabel(k)}:</span>
                            <span
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #e0d9f8",
                                color: "#271078",
                                borderRadius: "16px",
                                padding: "3px 10px",
                                fontSize: "12px",
                                fontWeight: "700",
                              }}
                            >
                              {Array.isArray(v) ? v.join(", ") : v}
                            </span>
                          </div>
                        ))}
                      </>
                    );
                  })()}
                </div>
                <button
                  onClick={() => {
                    setFilters({});
                    setSearch("");
                    setSearchInput("");
                    setCurrentPage(1);
                    // Force-remount the Filter panel to reset all internal dropdown state
                    setFilterResetKey((prev) => prev + 1);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#F99E52",
                    fontWeight: "700",
                    fontSize: "12px",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  ✕ Clear All
                </button>
              </div>
            </div>
          )}

          {/* <div className="bg-white px-10 py-4 mb-4 flex items-center ">
            <div
              className="flex flex-row shadow-lg"
              style={{
                overflow: "hidden",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                // width: "10%",
              }}
            >
              <button
                className={`py-2 px-3 font-semibold transition-all duration-300 ${
                  activeTab === "processed"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                }`}
                style={{
                  flex: 1,
                  borderRadius: "8px 0 0 8px",
                }}
                onClick={() => setActiveTab("processed")}
              >
                Processed
              </button>

              <button
                className={`py-2 px-3 font-semibold transition-all duration-300 ${
                  activeTab === "failed"
                    ? "bg-red-500 text-white"
                    : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                }`}
                style={{
                  flex: 1,
                  borderRadius: "0 8px 8px 0",
                }}
                onClick={() => setActiveTab("failed")}
              >
                Failed
              </button>
            </div>
          </div> */}
          {storage.getItem("role") !== "Agenth" &&
          storage.getItem("role") !== "Agent Collections" &&
          storage.getItem("role") !== "Agent" &&
          !storage.getItem("role").includes("Agent") ? (
            <div className="call-table" style={{ background: "white" }}>
              <div className="flex justify-between mb-4">
                <div className=" flex gap-2 items-center">
                  <span className="font-semibold text-2xl mx-3">
                    Upload Status :{" "}
                  </span>
                  <div
                    className="flex flex-row shadow-lg"
                    style={{
                      overflow: "hidden",
                      backgroundColor: "#f9f9f9",
                      borderRadius: "8px",
                      // width: "10%",
                      height: "30px",
                    }}
                  >
                    <button
                      className={`py-2 px-3 font-semibold transition-all duration-300 ${
                        activeTab === "processed"
                          ? "bg-green-600 text-white"
                          : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                      }`}
                      style={{
                        flex: 1,
                        borderRadius: "8px 0 0 8px",
                      }}
                      onClick={() => handleTabChange("processed")}
                    >
                      Processed
                    </button>

                    <button
                      className={`py-2 px-3 font-semibold transition-all duration-300  whitespace-nowrap ${
                        activeTab === "failed"
                          ? "bg-red-500 text-white"
                          : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                      }`}
                      style={{
                        flex: 1,
                        borderRadius: "0 8px 8px 0",
                      }}
                      onClick={() => handleTabChange("failed")}
                    >
                      Needs Review
                    </button>
                  </div>
                </div>

                {activeTab === "processed" && (
                  <div
                    className=" flex justify-end px-10 h-20 items-center mr-10 mb-1 mt-2 gap-4"
                    style={{ paddingBottom: "6px" }}
                  >
                    <input
                      value={searchInput}
                      onChange={handleSearchChange}
                      type="text"
                      placeholder="Search by customer,agent and product"
                      className="search-tag"
                      style={{
                        // border: "1px solid transparent",
                        border: "none",
                        background: "#eef2f5",
                        borderRadius: "10px",
                        width: "270px",
                        outline: "none",
                        paddingLeft: "8px",
                        height: "37px",
                      }}
                    />
                  </div>
                )}
              </div>

              {isPending ? (
                <div className=" flex justify-center">
                  <ClipLoader color="#2056FF" size="50px" />
                </div>
              ) : activeTab === "processed" ? (
                <>
                  <table className="ss call-list-table">
                    <thead>
                      {useCase === "Complaints Management" ? (
                        <tr className="complaint-mang">
                          <th>
                            <p> Date</p>
                          </th>
                          <th>
                            <p>Ticket Number </p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          <th>
                            <p>Services</p>
                          </th>
                          <th>
                            <p>Sentiments</p>
                          </th>
                          <th>
                            <p>Intent</p>
                          </th>

                          <th>
                            <p>Status</p>
                          </th>
                        </tr>
                      ) : useCase == "Third Party Collection Agency" ? (
                        <tr>
                          <th>
                            <p>Date</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Call ID</p>
                          </th>
                          <th>
                            <p>Agent</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          <th>
                            <p> Sentiments</p>
                          </th>

                          <th>
                            <p>Intent</p>
                          </th>
                          {/* <th className=" whitespace-nowrap">
        <p>Agent Recommendation</p>
      </th> */}
                          <th className=" whitespace-nowrap">
                            <p>Recommendation</p>
                          </th>
                        </tr>
                      ) : useCase == "Insurance - PCVC Verification" ? (
                        <tr>
                          <th>
                            <p>Call Date</p>
                          </th>
                          <th>
                            <p>NEMP Id</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>

                          <th>
                            <p>Product Type</p>
                          </th>

                          <th>
                            <p>Product</p>
                          </th>

                          <th>
                            <p>Status</p>
                          </th>
                        </tr>
                      ) : useCase == "Banking" ? (
                        <tr>
                          <th>
                            <p>Call Date</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Agent</p>
                          </th>
                          <th className=" whitespace-nowrap">
                            <p>Call ID</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          <th>
                            <p>Call Type</p>
                          </th>

                          <th>
                            <p>Sentiments</p>
                          </th>
                          <th>
                            <p>Intent</p>
                          </th>
                        </tr>
                      ) : (
                        <tr>
                          <th>
                            <p>Call Date</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Agent</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          {/* <th>
        <p>Call Type</p>
      </th> */}

                          <th>
                            <p>Call Category</p>
                          </th>
                          <th>
                            <p>Collection Status</p>
                          </th>
                          {storage.getItem("collection_module") === "true" && (
                            <>
                              {/* <th className=" whitespace-nowrap">
            <p>Agent Recommendation</p>
          </th> */}
                              <th className=" whitespace-nowrap">
                                <p>Collection Score</p>
                              </th>

                              <th className=" whitespace-nowrap">
                                <p>Collected</p>
                              </th>
                              <th className=" whitespace-nowrap">
                                <p>Target </p>
                              </th>
                            </>
                          )}
                          {/* <th>
        <p>Action</p>
      </th> */}
                        </tr>
                      )}
                    </thead>
                    {isPending && (
                      <tr
                        style={{
                          height: "400px",
                          textAlignVertical: "center",
                          textAlign: "center",
                        }}
                      >
                        <td colSpan="6">
                          <ClipLoader color="#2056FF" size="50px" />
                        </td>
                      </tr>
                    )}

                    {error && (
                      <tr
                        style={{
                          textAlignVertical: "center",
                          textAlign: "center",
                        }}
                      >
                        <td colSpan="6">
                          <p style={{ fontSize: "25px", color: "#FF8520" }}>
                            {error === "Connection Error" && (
                              <RiSignalWifiErrorFill />
                            )}
                            {error !== "Connection Error" && <BiError />}
                            {error}
                          </p>
                        </td>
                      </tr>
                    )}
                    <tbody className="complaint-mang">
                      {callList?.length > 0 && callList ? (
                        callList?.map((call) =>
                          useCase === "Complaints Management" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openComplainstInsight(call._id, call._intent)
                              }
                              className=" cus"
                            >
                              <td style={{ width: "10%" }}>{call?._date}</td>
                              <td style={{ width: "10%" }}>
                                {call?._ticket_number}
                              </td>
                              <td style={{ width: "10%" }}>
                                {call._language.includes("English")
                                  ? "English"
                                  : call._language}
                              </td>
                              <td style={{ width: "10%" }}>
                                {call._product_name}
                              </td>
                              <td style={{ width: "10%" }}>
                                {call._call_type}
                              </td>
                              <td style={{ width: "10%" }}>30%</td>
                              <td style={{ width: "10%" }}>50%</td>
                              <td style={{ width: "10%" }}>Closed</td>
                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : useCase === "Third Party Collection Agency" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call._date}</td>
                              <td>{call?._customer}</td>
                              {/* <td>{call?._nemp_id || "14CH452"}</td> */}
                              <td>{(call?._id).slice(0, 5).toUpperCase()}</td>
                              <td>{call?._agent}</td>
                              <td>{call?._language}</td>

                              <td>
                                {call?._product_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>
                              <td>
                                {Math.abs(Math.trunc(call?._sentiment * 100))}%
                              </td>
                              <td>
                                {Math.abs(Math.trunc(call?._intent * 100))}%
                              </td>
                              {storage.getItem("collection_module") ===
                                "true" && (
                                <>
                                  {call._intent !== 0 && (
                                    <>
                                      {call._call_type === "Collection" ? (
                                        <>
                                          {/* <td>
                        <p>{call._agent_collection_view}</p>
                      </td> */}
                                          <td>
                                            <p>
                                              {call._dataklout_collection_view}
                                            </p>
                                          </td>
                                        </>
                                      ) : (
                                        <>
                                          <td>
                                            <p>NA</p>
                                          </td>
                                          <td>
                                            <p>NA</p>
                                          </td>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : useCase == "Insurance - PCVC Verification" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call._date}</td>
                              <td>{call?._nemp_id}</td>
                              <td>{call?._customer}</td>
                              <td>{call?._language}</td>
                              <td>
                                {call?._category
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>
                              <td>
                                {call?._product_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>

                              {call?._intent !== 0 ? (
                                <td>
                                  {call?._call_status ? (
                                    <p
                                      className={`whitespace-nowrap ${
                                        call?._call_status === "non-fatal"
                                          ? "text-green-700"
                                          : "text-red-700"
                                      }`}
                                    >
                                      {call?._call_status
                                        .toLowerCase()
                                        .replace(/\b\w/g, function (a) {
                                          return a.toUpperCase();
                                        })}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              ) : (
                                ""
                              )}

                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              // progress={call?._progress}
                                              progress={call._progress}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : storage.getItem("usecase") === "Banking" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call._date}</td>
                              <td>{call?._customer}</td>
                              <td>{call?._agent}</td>
                              <td>{(call?._id).slice(0, 5).toUpperCase()}</td>
                              <td>
                                {call._language.includes("English")
                                  ? "English"
                                  : call._language}
                              </td>
                              {/* <td>{call?._nemp_id || "14CH452"}</td> */}

                              <td>
                                {call?._product_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>
                              <td>{call._call_type}</td>
                              {call._intent !== 0 && (
                                <>
                                  <td>
                                    {call._sentiment > 0 ? (
                                      <p
                                        className="red"
                                        style={{ color: "green" }}
                                      >
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    ) : (
                                      <p
                                        className="red"
                                        style={{ color: "red" }}
                                      >
                                        <i
                                          className="fa fa-minus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    )}
                                  </td>
                                  <td>
                                    {call._intent > 0 ? (
                                      <p
                                        className="red"
                                        style={{ color: "green" }}
                                      >
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    ) : (
                                      <p
                                        className="red"
                                        style={{ color: "red" }}
                                      >
                                        <i
                                          className="fa fa-minus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    )}
                                  </td>
                                </>
                              )}

                              {/* <td>{Math.abs(Math.trunc(call?._sentiment * 100))}%</td>
        <td>{Math.abs(Math.trunc(call?._intent * 100))}%</td> */}
                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call?._date}</td>
                              <td>{call?._customer}</td>
                              <td>{call?._agent}</td>
                              <td>
                                {call._language.includes("English")
                                  ? "English"
                                  : call._language}
                              </td>
                              <td>{call._product_name}</td>
                              {/* <td>{call._call_type}</td> */}

                              {call._intent !== 0 && (
                                <>
                                  <td>{call._due_category}</td>
                                  <td>
                                    <p>{call._dataklout_collection_view}</p>
                                  </td>
                                </>
                              )}

                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}

                              <td>
                                <p>{call._call_collection_score || "-"}</p>
                              </td>

                              {useCase.includes("Collections") && (
                                <td className="text-left ">
                                  <p>
                                    {call._collected_amount_formatted
                                      ? call._collected_amount_formatted
                                      : "-"}
                                  </p>
                                </td>
                              )}
                              {useCase.includes("Collections") && (
                                <td className="text-left ">
                                  <p>
                                    {call._target_amount_formatted
                                      ? call._target_amount_formatted
                                      : "-"}
                                  </p>
                                </td>
                              )}
                            </tr>
                          ),
                        )
                      ) : (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            No Record Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              ) : (
                <div className="bg-white py-4 mb-4">
                  <div className="flex justify-end items-center mb-6 px-10 gap-3">
                    <span
                      className="font-bold text-gray-500"
                      style={{ fontSize: "14px" }}
                    >
                      View As :
                    </span>
                    <div
                      className="flex shadow-inner"
                      style={{
                        backgroundColor: "#f3f4f6",
                        padding: "3px",
                        borderRadius: "10px",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <button
                        className="transition-all duration-300"
                        style={{
                          padding: "5px 16px",
                          backgroundColor:
                            failedSubTab === "deviance"
                              ? "white"
                              : "transparent",
                          color:
                            failedSubTab === "deviance" ? "#ef4444" : "#6b7280",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "12px",
                          boxShadow:
                            failedSubTab === "deviance"
                              ? "0 1px 3px rgba(0,0,0,0.12)"
                              : "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSubTabChange("deviance")}
                      >
                        Deviance Calls
                      </button>
                      <button
                        className="transition-all duration-300"
                        style={{
                          padding: "5px 16px",
                          backgroundColor:
                            failedSubTab === "failed_upload"
                              ? "white"
                              : "transparent",
                          color:
                            failedSubTab === "failed_upload"
                              ? "#ef4444"
                              : "#6b7280",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "12px",
                          boxShadow:
                            failedSubTab === "failed_upload"
                              ? "0 1px 3px rgba(0,0,0,0.12)"
                              : "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSubTabChange("failed_upload")}
                      >
                        Failed Uploads
                      </button>
                    </div>
                  </div>

                  {failedSubTab === "failed_upload" ? (
                    <>
                      {/* <h4 className=" font-semibold text-red-600">
                  Failed Call Upload
                </h4> */}
                      {console.log(failedlist.length)}
                      {failedlist?.length <= 0 ? (
                        <div className="rounded-lg p-6 bg-gray-100 my-4 ml-6 mr-6">
                          <div className=" flex justify-center items-center text-2xl font-semibold text-gray-500 my-40">
                            No Records Found
                          </div>
                        </div>
                      ) : (
                        failedlist?.map((items, i) => (
                          <div className="rounded-lg p-6 bg-gray-100 space-y-4 my-4 ml-6 mr-6">
                            <div className="flex justify-between items-center cursor-pointer">
                              <h4
                                className="text-gray-800"
                                style={{ fontSize: "14px" }}
                              >
                                Bulk Upload on {items?.upload_date}-{" "}
                                <span className=" text-red-600">
                                  {" "}
                                  {items?.errors.length} Calls Failed
                                </span>
                              </h4>
                              <div className="flex items-center">
                                <div className="" style={{ fontSize: "14px" }}>
                                  <button
                                    className="px-8 py-3 rounded-xl  tracking-wide font-semibold bg-white failed-csv"
                                    style={{ border: "1px solid gray" }}
                                    onClick={() =>
                                      handledownloadCSV(items?.batch_id)
                                    }
                                  >
                                    Download CSV
                                  </button>
                                </div>
                                <span
                                  className="ml-2 text-gray-500 text-xl"
                                  onClick={() => toggleExpand(i)}
                                >
                                  {expandedStates[i] ? (
                                    <img
                                      src={arrowDown}
                                      alt="arrow-down"
                                      className="transform rotate-180"
                                    />
                                  ) : (
                                    <img src={arrowDown} alt="arrow-down" />
                                  )}
                                </span>
                              </div>
                            </div>
                            <div
                              className={`transition-all duration-600 ease-in-out ${
                                expandedStates[i]
                                  ? "opacity-100 overflow-y-auto "
                                  : "max-h-0 opacity-0 overflow-hidden"
                              }`}
                              style={{
                                maxHeight: expandedStates[i] ? "457px" : "0px",
                              }}
                            >
                              {/* <ul className=" list-disc list-inside text-gray-700 space-y-2 text-2xl font-semibold">
                        <li>jhdsvj,smfbd</li>
                      </ul> */}

                              <table
                                className="min-w-full bg-white"
                                style={{
                                  borderCollapse: "collapse",
                                  border: "1px solid #d1d5db",
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                }}
                              >
                                <thead className="font-semibold text-gray-800">
                                  <tr>
                                    <th
                                      className="px-6 py-3 text-left text-xl  text-black uppercase tracking-wider"
                                      style={{
                                        border: "1px solid #d1d5db",
                                        padding: "10px 10px",
                                        position: "inherit",
                                      }}
                                    >
                                      Sr No
                                    </th>
                                    <th
                                      className="px-6 py-3 text-left text-xl  text-black uppercase tracking-wider"
                                      style={{
                                        border: "1px solid #d1d5db",
                                        padding: "10px 10px",
                                        position: "inherit",
                                      }}
                                    >
                                      Call
                                    </th>
                                    <th
                                      className="px-6 py-3 text-left text-xl  text-black uppercase tracking-wider"
                                      style={{
                                        border: "1px solid #d1d5db",
                                        padding: "10px 10px",
                                      }}
                                    >
                                      Issue
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  className=""
                                  style={{ backgroundColor: "white" }}
                                >
                                  {items?.errors.map((errorItem, index) => (
                                    <tr style={{ backgroundColor: "white" }}>
                                      <td
                                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        style={{ border: "1px solid #d1d5db" }}
                                      >
                                        {index + 1}
                                      </td>
                                      <td
                                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        style={{ border: "1px solid #d1d5db" }}
                                      >
                                        {errorItem?.recording}
                                      </td>
                                      <td
                                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        style={{ border: "1px solid #d1d5db" }}
                                      >
                                        {errorItem?.error}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <div className=" mx-2 my-2 text-red-600">
                                {" "}
                                * Download the CSV file, Correct the details and
                                Reupload the CSV for call processing.
                              </div>
                            </div>
                            {expandedStates[i] && items?.errors.length > 10 && (
                              <div className="flex justify-center items-center">
                                <div
                                  className=" rounded-full p-2 w-12 h-12 bg-white flex justify-center items-center"
                                  style={{ border: " 1px solid lightgray" }}
                                >
                                  <img src={arrowScroll} alt="arrow-scroll" />
                                </div>
                              </div>
                            )}
                          </div>
                        ))
                      )}
                    </>
                  ) : (
                    <div className="px-6">
                      {isDeviancePending ? (
                        <div className=" flex justify-center py-20">
                          <ClipLoader color="#2056FF" size="50px" />
                        </div>
                      ) : (
                        <>
                          <table className="ss call-list-table">
                            <thead>
                              <tr>
                                <th>
                                  <p>Call Date</p>
                                </th>
                                <th>
                                  <p>Audit Date</p>
                                </th>
                                <th>
                                  <p>Customer</p>
                                </th>
                                <th>
                                  <p>Product</p>
                                </th>
                                <th>
                                  <p>Language</p>
                                </th>
                                <th>
                                  <p>Agent</p>
                                </th>
                                <th>
                                  <p>Category</p>
                                </th>

                                <th>
                                  <p>Total Points</p>
                                </th>
                                {storage.getItem("username") ===
                                  "MYABCMR01" && (
                                  <th>
                                    <p>Review</p>
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {devianceCalls?.length > 0 ? (
                                devianceCalls.map((call) => (
                                  <tr
                                    key={call.id}
                                    onClick={() =>
                                      history.push(
                                        `/call/${call.call_id}/call-insight`,
                                      )
                                    }
                                    className="cus"
                                  >
                                    <td>{call.call_date}</td>
                                    <td>{call.audit_date}</td>
                                    <td>{call.customer_name}</td>
                                    <td>{call.product}</td>
                                    <td>{call.language}</td>
                                    <td>{call.agent}</td>
                                    <td>{call.due_category}</td>
                                    <td>{call.total_points}</td>
                                    {storage.getItem("username") ===
                                      "MYABCMR01" && (
                                      <td className="text-left ">
                                        {call?.call_reviewed ? (
                                          <p className=" flex justify-start font-bold green">
                                            <i
                                              class="fa fa-check-circle"
                                              aria-hidden="true"
                                            ></i>
                                          </p>
                                        ) : (
                                          <p
                                            className="flex justify-start font-bold
                             "
                                            style={{ color: "red" }}
                                          >
                                            <i
                                              class="fa fa-times-circle"
                                              aria-hidden="true"
                                            ></i>
                                          </p>
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="8"
                                    style={{ textAlign: "center" }}
                                  >
                                    No Record Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              {activeTab === "processed" && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalpage.length}
                  onPageChange={handlePageClick}
                  totalresult={totalresult}
                />
              )}
              {activeTab === "failed" && failedSubTab === "deviance" && (
                <Pagination
                  currentPage={devianceCurrentPage}
                  totalPages={devianceTotalPages.length}
                  onPageChange={handleDeviancePageClick}
                  totalresult={devianceTotalResult}
                />
              )}
            </div>
          ) : (
            <div className="call-table" style={{ background: "white" }}>
              {isPending ? (
                <div className=" flex justify-center">
                  <ClipLoader color="#2056FF" size="50px" />
                </div>
              ) : activeTab === "processed" ? (
                <>
                  <table className="ss call-list-table">
                    <thead>
                      {useCase === "Complaints Management" ? (
                        <tr className="complaint-mang">
                          <th>
                            <p>Date</p>
                          </th>
                          <th>
                            <p>Ticket Number </p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          <th>
                            <p>Services</p>
                          </th>
                          <th>
                            <p>Sentiments</p>
                          </th>
                          <th>
                            <p>Intent</p>
                          </th>

                          <th>
                            <p>Status</p>
                          </th>
                        </tr>
                      ) : useCase == "Third Party Collection Agency" ? (
                        <tr>
                          <th>
                            <p>Date</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Call ID</p>
                          </th>
                          <th>
                            <p>Agent</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          <th>
                            <p> Sentiments</p>
                          </th>

                          <th>
                            <p>Intent</p>
                          </th>
                          {/* <th className=" whitespace-nowrap">
        <p>Agent Recommendation</p>
      </th> */}
                          <th className=" whitespace-nowrap">
                            <p>Recommendation</p>
                          </th>
                        </tr>
                      ) : useCase == "Insurance - PCVC Verification" ? (
                        <tr>
                          <th>
                            <p>Call Date</p>
                          </th>
                          <th>
                            <p>NEMP Id</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>

                          <th>
                            <p>Product Type</p>
                          </th>

                          <th>
                            <p>Product</p>
                          </th>

                          <th>
                            <p>Status</p>
                          </th>
                        </tr>
                      ) : useCase == "Banking" ? (
                        <tr>
                          <th>
                            <p>Call Date</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Agent</p>
                          </th>
                          <th className=" whitespace-nowrap">
                            <p>Call ID</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          <th>
                            <p>Call Type</p>
                          </th>

                          <th>
                            <p>Sentiments</p>
                          </th>
                          <th>
                            <p>Intent</p>
                          </th>
                        </tr>
                      ) : (
                        <tr>
                          <th>
                            <p>Call Date</p>
                          </th>
                          <th>
                            <p>Customer</p>
                          </th>
                          <th>
                            <p>Agent</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Product</p>
                          </th>
                          {/* <th>
        <p>Call Type</p>
      </th> */}

                          <th>
                            <p>Call Category</p>
                          </th>
                          <th>
                            <p>Collection Status</p>
                          </th>
                          {storage.getItem("collection_module") === "true" && (
                            <>
                              {/* <th className=" whitespace-nowrap">
            <p>Agent Recommendation</p>
          </th> */}
                              <th className=" whitespace-nowrap">
                                <p>Collection Score</p>
                              </th>

                              <th className=" whitespace-nowrap">
                                <p>Collected</p>
                              </th>
                              <th className=" whitespace-nowrap">
                                <p>Target </p>
                              </th>
                            </>
                          )}
                          {/* <th>
        <p>Action</p>
      </th> */}
                        </tr>
                      )}
                    </thead>
                    {isPending && (
                      <tr
                        style={{
                          height: "400px",
                          textAlignVertical: "center",
                          textAlign: "center",
                        }}
                      >
                        <td colSpan="6">
                          <ClipLoader color="#2056FF" size="50px" />
                        </td>
                      </tr>
                    )}

                    {error && (
                      <tr
                        style={{
                          textAlignVertical: "center",
                          textAlign: "center",
                        }}
                      >
                        <td colSpan="6">
                          <p style={{ fontSize: "25px", color: "#FF8520" }}>
                            {error === "Connection Error" && (
                              <RiSignalWifiErrorFill />
                            )}
                            {error !== "Connection Error" && <BiError />}
                            {error}
                          </p>
                        </td>
                      </tr>
                    )}
                    <tbody className="complaint-mang">
                      {callList?.length > 0 ? (
                        callList?.map((call) =>
                          useCase === "Complaints Management" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openComplainstInsight(call._id, call._intent)
                              }
                              className=" cus"
                            >
                              <td style={{ width: "10%" }}>{call?._date}</td>
                              <td style={{ width: "10%" }}>
                                {call?._ticket_number}
                              </td>
                              <td style={{ width: "10%" }}>
                                {call._language.includes("English")
                                  ? "English"
                                  : call._language}
                              </td>
                              <td style={{ width: "10%" }}>
                                {call._product_name}
                              </td>
                              <td style={{ width: "10%" }}>
                                {call._call_type}
                              </td>
                              <td style={{ width: "10%" }}>30%</td>
                              <td style={{ width: "10%" }}>50%</td>
                              <td style={{ width: "10%" }}>Closed</td>
                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : useCase === "Third Party Collection Agency" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call._date}</td>
                              <td>{call?._customer}</td>
                              {/* <td>{call?._nemp_id || "14CH452"}</td> */}
                              <td>{(call?._id).slice(0, 5).toUpperCase()}</td>
                              <td>{call?._agent}</td>
                              <td>{call?._language}</td>

                              <td>
                                {call?._product_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>
                              <td>
                                {Math.abs(Math.trunc(call?._sentiment * 100))}%
                              </td>
                              <td>
                                {Math.abs(Math.trunc(call?._intent * 100))}%
                              </td>
                              {storage.getItem("collection_module") ===
                                "true" && (
                                <>
                                  {call._intent !== 0 && (
                                    <>
                                      {call._call_type === "Collection" ? (
                                        <>
                                          {/* <td>
                        <p>{call._agent_collection_view}</p>
                      </td> */}
                                          <td>
                                            <p>
                                              {call._dataklout_collection_view}
                                            </p>
                                          </td>
                                        </>
                                      ) : (
                                        <>
                                          <td>
                                            <p>NA</p>
                                          </td>
                                          <td>
                                            <p>NA</p>
                                          </td>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : useCase == "Insurance - PCVC Verification" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call._date}</td>
                              <td>{call?._nemp_id}</td>
                              <td>{call?._customer}</td>
                              <td>{call?._language}</td>
                              <td>
                                {call?._category
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>
                              <td>
                                {call?._product_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>

                              {call?._intent !== 0 ? (
                                <td>
                                  {call?._call_status ? (
                                    <p
                                      className={`whitespace-nowrap ${
                                        call?._call_status === "non-fatal"
                                          ? "text-green-700"
                                          : "text-red-700"
                                      }`}
                                    >
                                      {call?._call_status
                                        .toLowerCase()
                                        .replace(/\b\w/g, function (a) {
                                          return a.toUpperCase();
                                        })}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              ) : (
                                ""
                              )}

                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              // progress={call?._progress}
                                              progress={call._progress}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : storage.getItem("usecase") === "Banking" ? (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call._date}</td>
                              <td>{call?._customer}</td>
                              <td>{call?._agent}</td>
                              <td>{(call?._id).slice(0, 5).toUpperCase()}</td>
                              <td>
                                {call._language.includes("English")
                                  ? "English"
                                  : call._language}
                              </td>
                              {/* <td>{call?._nemp_id || "14CH452"}</td> */}

                              <td>
                                {call?._product_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                              </td>
                              <td>{call._call_type}</td>
                              {call._intent !== 0 && (
                                <>
                                  <td>
                                    {call._sentiment > 0 ? (
                                      <p
                                        className="red"
                                        style={{ color: "green" }}
                                      >
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    ) : (
                                      <p
                                        className="red"
                                        style={{ color: "red" }}
                                      >
                                        <i
                                          className="fa fa-minus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    )}
                                  </td>
                                  <td>
                                    {call._intent > 0 ? (
                                      <p
                                        className="red"
                                        style={{ color: "green" }}
                                      >
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    ) : (
                                      <p
                                        className="red"
                                        style={{ color: "red" }}
                                      >
                                        <i
                                          className="fa fa-minus-circle"
                                          aria-hidden="true"
                                        />
                                      </p>
                                    )}
                                  </td>
                                </>
                              )}

                              {/* <td>{Math.abs(Math.trunc(call?._sentiment * 100))}%</td>
        <td>{Math.abs(Math.trunc(call?._intent * 100))}%</td> */}
                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}
                            </tr>
                          ) : (
                            <tr
                              key={call._id}
                              onClick={() =>
                                openCallInsight(call._id, call._intent)
                              }
                            >
                              <td>{call?._date}</td>
                              <td>{call?._customer}</td>
                              <td>{call?._agent}</td>
                              <td>
                                {call._language.includes("English")
                                  ? "English"
                                  : call._language}
                              </td>
                              <td>{call._product_name}</td>
                              {/* <td>{call._call_type}</td> */}

                              {call._intent !== 0 && (
                                <>
                                  <td>{call._due_category}</td>
                                  <td>
                                    <p>{call._dataklout_collection_view}</p>
                                  </td>
                                </>
                              )}

                              {call._intent === 0 && (
                                <>
                                  {storage.getItem("collection_module") ===
                                    "true" && (
                                    <td
                                      colSpan="4"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}

                                  {storage.getItem("collection_module") !==
                                    "true" && (
                                    <td
                                      colSpan="2"
                                      data-toggle="tooltip"
                                      data-placement="left"
                                      title={call._processing_status}
                                    >
                                      {call._processing_status !== "Failed" && (
                                        <>
                                          <div className="col-md-10">
                                            <ProgressBar
                                              bgcolor="#271078"
                                              progress={call._progress}
                                              // progress={progess}
                                              height={20}
                                            />
                                          </div>
                                          <div className="col-md-2">
                                            <PulseLoader
                                              color="#2056FF"
                                              size="10px"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {call._processing_status === "Failed" && (
                                        <>
                                          <BiError
                                            size="20px"
                                            color="#FF0800"
                                          />{" "}
                                          Call Processing Failed, Need Action
                                          <a
                                            onClick={() =>
                                              removeFailedItem(call._id)
                                            }
                                            className="pull-right"
                                            style={{ color: "red" }}
                                          >
                                            <RiDeleteRow size="20px" />{" "}
                                            Remove{" "}
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  )}
                                </>
                              )}

                              <td>
                                <p>{call._call_collection_score || "-"}</p>
                              </td>

                              {useCase.includes("Collections") && (
                                <td className="text-left ">
                                  <p>
                                    {call._collected_amount_formatted
                                      ? call._collected_amount_formatted
                                      : "-"}
                                  </p>
                                </td>
                              )}
                              {useCase.includes("Collections") && (
                                <td className="text-left ">
                                  <p>
                                    {call._target_amount_formatted
                                      ? call._target_amount_formatted
                                      : "-"}
                                  </p>
                                </td>
                              )}
                            </tr>
                          ),
                        )
                      ) : (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            No Record Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              ) : (
                <div className="bg-white py-4 mb-4">
                  <div className="flex justify-end items-center mb-6 px-10 gap-3">
                    <span
                      className="font-bold text-gray-500"
                      style={{ fontSize: "14px" }}
                    >
                      View As :
                    </span>
                    <div
                      className="flex shadow-inner"
                      style={{
                        backgroundColor: "#f3f4f6",
                        padding: "3px",
                        borderRadius: "10px",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <button
                        className="transition-all duration-300"
                        style={{
                          padding: "5px 16px",
                          backgroundColor:
                            failedSubTab === "deviance"
                              ? "white"
                              : "transparent",
                          color:
                            failedSubTab === "deviance" ? "#ef4444" : "#6b7280",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "12px",
                          boxShadow:
                            failedSubTab === "deviance"
                              ? "0 1px 3px rgba(0,0,0,0.12)"
                              : "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSubTabChange("deviance")}
                      >
                        Deviance Calls
                      </button>
                      <button
                        className="transition-all duration-300"
                        style={{
                          padding: "5px 16px",
                          backgroundColor:
                            failedSubTab === "failed_upload"
                              ? "white"
                              : "transparent",
                          color:
                            failedSubTab === "failed_upload"
                              ? "#ef4444"
                              : "#6b7280",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "12px",
                          boxShadow:
                            failedSubTab === "failed_upload"
                              ? "0 1px 3px rgba(0,0,0,0.12)"
                              : "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSubTabChange("failed_upload")}
                      >
                        Failed Uploads
                      </button>
                    </div>
                  </div>

                  {failedSubTab === "failed_upload" ? (
                    <>
                      {/* <h4 className=" font-semibold text-red-600">
                  Failed Call Upload
                </h4> */}
                      {console.log(failedlist.length)}
                      {failedlist?.length <= 0 ? (
                        <div className="rounded-lg p-6 bg-gray-100 my-4 ml-6 mr-6">
                          <div className=" flex justify-center items-center text-2xl font-semibold text-gray-500 my-40">
                            No Records Found
                          </div>
                        </div>
                      ) : (
                        failedlist?.map((items, i) => (
                          <div className="rounded-lg p-6 bg-gray-100 space-y-4 my-4 ml-6 mr-6">
                            <div className="flex justify-between items-center cursor-pointer">
                              <h4
                                className="text-gray-800"
                                style={{ fontSize: "14px" }}
                              >
                                Bulk Upload on {items?.upload_date}-{" "}
                                <span className=" text-red-600">
                                  {" "}
                                  {items?.errors.length} Calls Failed
                                </span>
                              </h4>
                              <div className="flex items-center">
                                <div className="" style={{ fontSize: "14px" }}>
                                  <button
                                    className="px-8 py-3 rounded-xl  tracking-wide font-semibold bg-white failed-csv"
                                    style={{ border: "1px solid gray" }}
                                    onClick={() =>
                                      handledownloadCSV(items?.batch_id)
                                    }
                                  >
                                    Download CSV
                                  </button>
                                </div>
                                <span
                                  className="ml-2 text-gray-500 text-xl"
                                  onClick={() => toggleExpand(i)}
                                >
                                  {expandedStates[i] ? (
                                    <img
                                      src={arrowDown}
                                      alt="arrow-down"
                                      className="transform rotate-180"
                                    />
                                  ) : (
                                    <img src={arrowDown} alt="arrow-down" />
                                  )}
                                </span>
                              </div>
                            </div>
                            <div
                              className={`transition-all duration-600 ease-in-out ${
                                expandedStates[i]
                                  ? "opacity-100 overflow-y-auto "
                                  : "max-h-0 opacity-0 overflow-hidden"
                              }`}
                              style={{
                                maxHeight: expandedStates[i] ? "457px" : "0px",
                              }}
                            >
                              {/* <ul className=" list-disc list-inside text-gray-700 space-y-2 text-2xl font-semibold">
                        <li>jhdsvj,smfbd</li>
                      </ul> */}

                              <table
                                className="min-w-full bg-white"
                                style={{
                                  borderCollapse: "collapse",
                                  border: "1px solid #d1d5db",
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                }}
                              >
                                <thead className="font-semibold text-gray-800">
                                  <tr>
                                    <th
                                      className="px-6 py-3 text-left text-xl  text-black uppercase tracking-wider"
                                      style={{
                                        border: "1px solid #d1d5db",
                                        padding: "10px 10px",
                                        position: "inherit",
                                      }}
                                    >
                                      Sr No
                                    </th>
                                    <th
                                      className="px-6 py-3 text-left text-xl  text-black uppercase tracking-wider"
                                      style={{
                                        border: "1px solid #d1d5db",
                                        padding: "10px 10px",
                                        position: "inherit",
                                      }}
                                    >
                                      Call
                                    </th>
                                    <th
                                      className="px-6 py-3 text-left text-xl  text-black uppercase tracking-wider"
                                      style={{
                                        border: "1px solid #d1d5db",
                                        padding: "10px 10px",
                                      }}
                                    >
                                      Issue
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  className=""
                                  style={{ backgroundColor: "white" }}
                                >
                                  {items?.errors.map((errorItem, index) => (
                                    <tr style={{ backgroundColor: "white" }}>
                                      <td
                                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        style={{ border: "1px solid #d1d5db" }}
                                      >
                                        {index + 1}
                                      </td>
                                      <td
                                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        style={{ border: "1px solid #d1d5db" }}
                                      >
                                        {errorItem?.recording}
                                      </td>
                                      <td
                                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        style={{ border: "1px solid #d1d5db" }}
                                      >
                                        {errorItem?.error}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <div className=" mx-2 my-2 text-red-600">
                                {" "}
                                * Download the CSV file, Correct the details and
                                Reupload the CSV for call processing.
                              </div>
                            </div>
                            {expandedStates[i] && items?.errors.length > 10 && (
                              <div className="flex justify-center items-center">
                                <div
                                  className=" rounded-full p-2 w-12 h-12 bg-white flex justify-center items-center"
                                  style={{ border: " 1px solid lightgray" }}
                                >
                                  <img src={arrowScroll} alt="arrow-scroll" />
                                </div>
                              </div>
                            )}
                          </div>
                        ))
                      )}
                    </>
                  ) : (
                    <div className="px-6">
                      {isDeviancePending ? (
                        <div className=" flex justify-center py-20">
                          <ClipLoader color="#2056FF" size="50px" />
                        </div>
                      ) : (
                        <>
                          <table className="ss call-list-table">
                            <thead>
                              <tr>
                                <th>
                                  <p>Call Date</p>
                                </th>
                                <th>
                                  <p>Audit Date</p>
                                </th>
                                <th>
                                  <p>Customer</p>
                                </th>
                                <th>
                                  <p>Product</p>
                                </th>
                                <th>
                                  <p>Language</p>
                                </th>
                                <th>
                                  <p>Agent</p>
                                </th>
                                <th>
                                  <p>Category</p>
                                </th>

                                <th>
                                  <p>Total Points</p>
                                </th>
                                <th>
                                  <p>Manual Audit</p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {devianceCalls?.length > 0 ? (
                                devianceCalls.map((call) => (
                                  <tr
                                    key={call.id}
                                    onClick={() =>
                                      history.push(
                                        `/call/${call.call_id}/call-insight`,
                                      )
                                    }
                                    className="cus"
                                  >
                                    <td>{call.call_date}</td>
                                    <td>{call.audit_date}</td>
                                    <td>{call.customer_name}</td>
                                    <td>{call.product}</td>
                                    <td>{call.language}</td>
                                    <td>{call.agent}</td>
                                    <td>{call.due_category}</td>
                                    <td>{call.total_points}</td>
                                    <td className="text-left ">
                                      {call?.call_reviewed ? (
                                        <p className=" flex justify-start font-bold green">
                                          <i
                                            class="fa fa-check-circle"
                                            aria-hidden="true"
                                          ></i>
                                        </p>
                                      ) : (
                                        <p
                                          className="flex justify-start font-bold
                             "
                                          style={{ color: "red" }}
                                        >
                                          <i
                                            class="fa fa-times-circle"
                                            aria-hidden="true"
                                          ></i>
                                        </p>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="8"
                                    style={{ textAlign: "center" }}
                                  >
                                    No Record Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              {activeTab === "processed" && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalpage.length}
                  onPageChange={handlePageClick}
                  totalresult={totalresult}
                />
              )}
              {activeTab === "failed" && failedSubTab === "deviance" && (
                <Pagination
                  currentPage={devianceCurrentPage}
                  totalPages={devianceTotalPages.length}
                  onPageChange={handleDeviancePageClick}
                  totalresult={devianceTotalResult}
                />
              )}
            </div>
          )}
        </div>
      </div>

      <Footer />
      {showCallModal && (
        <div className="modal my-calls-popup show">
          <div className="backdrop"></div>
          <div className="modal-dialog" role="document">
            <div className="my-calls-popup-details">
              <h2>
                <div className="icon-div">
                  <div>
                    <span>
                      <img
                        src="assets/images/user-icon.png"
                        className="img-responsive"
                        alt=""
                      />
                    </span>
                  </div>
                </div>
                {bulkupload ? "Add Bulk Call" : "Add New Call"}
              </h2>
              <div className="text-end mt-6" style={{ textAlign: "end" }}>
                <button
                  className=" px-4 py-2 bulk-upload"
                  style={{ border: "1px solid black" }}
                  onClick={() => {
                    setBulkupload(!bulkupload);
                    setEmptycall(false);
                    setSupportingInfoError("");
                    setUploadError(null);
                  }}
                >
                  {bulkupload ? "Single Upload" : "Bulk Upload"}
                </button>
              </div>

              {!bulkupload ? (
                <span>
                  <div className="my-calls-form">
                    {supportingInfo && (
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-col clearfix">
                            <label>Call Type </label>
                            <br />
                            <select
                              onChange={(e) => setCallType(e.target.value)}
                            >
                              <option value=""></option>
                              {supportingInfo.call_type.map((callType) => (
                                <option value={callType.title}>
                                  {callType.title}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-col clearfix">
                            <label>Product </label>
                            <br />
                            <select
                              onChange={(e) => setProduct(e.target.value)}
                            >
                              <option value=""></option>
                              {supportingInfo.product.map((product) => (
                                <option value={product.title}>
                                  {product.title}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-col clearfix">
                            <label>Language </label>
                            <br />
                            <select
                              onChange={(e) => setLanguageCode(e.target.value)}
                            >
                              <option value=""></option>
                              {supportingInfo.language.map((languageItem) => (
                                <option value={languageItem.code}>
                                  {languageItem.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-col clearfix">
                            <label>Customer </label>
                            <br />

                            <Select
                              options={[
                                { value: "add-new", label: "＋ Add New" },
                                ...supportingInfo.customer.map(
                                  (customerItem) => ({
                                    value: customerItem.id,
                                    label: [
                                      customerItem.salutation,
                                      customerItem.first_name,
                                      customerItem.middle_name,
                                      customerItem.last_name,
                                    ]
                                      .filter(Boolean)
                                      .join(" "),
                                  }),
                                ),
                              ]}
                              value={
                                customerID
                                  ? (() => {
                                      const customer =
                                        supportingInfo.customer.find(
                                          (customer) =>
                                            customer.id === customerID,
                                        );

                                      return customer
                                        ? {
                                            value: customerID,
                                            label: [
                                              customer.salutation,
                                              customer.first_name,
                                              customer.middle_name,
                                              customer.last_name,
                                            ]
                                              .filter(Boolean)
                                              .join(" "),
                                          }
                                        : null;
                                    })()
                                  : null
                              }
                              onChange={(selectedOption) => {
                                if (selectedOption.value === "add-new") {
                                  setNewcustomer(true);
                                } else {
                                  setCustomerID(selectedOption.value);
                                }
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: "#e6eaed",
                                  height: "44px",
                                  border: "none",
                                  outline: "none",
                                  boxShadow: "none",
                                  "&:focus": {
                                    outline: "none",
                                    boxShadow: "none",
                                  },
                                }),
                                container: (baseStyles, state) => ({
                                  ...baseStyles,
                                }),
                                indicatorSeparator: (baseStyles, state) => ({
                                  ...baseStyles,
                                  width: "0px",
                                }),
                                dropdownIndicator: (baseStyles, state) => ({
                                  ...baseStyles,
                                  margin: "0px 10px 15px 10px",
                                  borderRadius: "100%",
                                  border: "2px solid ",
                                  padding: "0px",
                                }),
                              }}
                              noOptionsMessage={() => null}
                              placeholder=""
                            />
                          </div>

                          <div className="form-col clearfix">
                            <label>Call Recording </label>
                            <br />
                            <input
                              style={{ padding: "7px" }}
                              type="file"
                              accept=".mp3, .mp4, .m4a, .flac, .ogg, .opus, .webm, .wma, .aac, .wav"
                              onChange={(e) => setUploadFile(e.target.files[0])}
                            />
                          </div>
                          <div className="form-col clearfix">
                            <label>Call Category </label>
                            <br />
                            <select
                              onChange={(e) =>
                                setCallCategory(
                                  e.target.value === "Internal" ? true : false,
                                )
                              }
                            >
                              <option value=""></option>
                              {["Internal", "External"].map((callCategory) => (
                                <option value={callCategory}>
                                  {callCategory}
                                </option>
                              ))}
                            </select>
                            {console.log(callCategory)}
                          </div>
                        </div>
                      </div>
                    )}

                    {supportingInfoPending && (
                      <div className="empty-call">Loading...</div>
                    )}
                    <div className="row">
                      <div className="col-md-12">
                        <p className="errorColor">{supportingInfoError}</p>
                        {uploadError && (
                          <p className="errorColor">{uploadError}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="border"></div>
                  <div className="popup-footer">
                    {!uploadPending && (
                      <>
                        <button
                          className="btn"
                          type="button"
                          onClick={() => {
                            toggolCallModal();
                            setCustomerID("");
                          }}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                        <button
                          className="btn Save"
                          type="button"
                          onClick={uploadCallRecording}
                        >
                          {" "}
                          Upload{" "}
                        </button>
                      </>
                    )}

                    {uploadPending && (
                      <ProgressBar
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Tooltip on top"
                        bgcolor="#271078"
                        progress={callUploadProgress}
                        height={20}
                      />
                    )}
                  </div>
                </span>
              ) : (
                <span>
                  <div className="my-calls-form">
                    {supportingInfo && (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-col clearfix">
                            <label htmlFor="">Upload CSV </label>
                            <br />

                            <label
                              htmlFor="csv-upload"
                              className="flex justify-center items-center flex-col bg-blue-50 gap-4 cursor-pointer"
                              style={{
                                marginTop: "10px",
                                border: "1px dotted blue",
                                height: "200px",
                              }}
                            >
                              <img
                                src={uploadIcon}
                                alt="upload-icon"
                                className="w-12 h-12"
                              />
                              <div className="text-blue-600 text-2xl text-center px-4">
                                {selectedFileName
                                  ? selectedFileName
                                  : "Select a CSV file to upload"}
                                {selectedFileName ? (
                                  <span
                                    style={{ color: "black" }}
                                    className="ml-4"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClearFile(e);
                                    }}
                                  >
                                    x
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>

                              <input
                                id="csv-upload"
                                type="file"
                                accept=".csv"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />
                            </label>

                            <div className="mt-4 text-xl flex justify-between">
                              <div className="relative w-full">
                                <span>
                                  How to upload bulk calls?
                                  <span
                                    className="text-blue-600 ml-2 cursor-pointer"
                                    onClick={() => {
                                      setIsKnowMoreOpen(true);
                                      // console.log("hyhy");
                                    }}
                                  >
                                    Know More
                                  </span>
                                </span>
                                {isKnowMoreOpen && (
                                  <div
                                    className="absolute mt-2 p-6 h-auto bg-white border border-gray-200 rounded-lg shadow-lg z-10 left-60"
                                    style={{ maxWidth: "500px" }}
                                  >
                                    <button
                                      className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                                      onClick={() => setIsKnowMoreOpen(false)}
                                    >
                                      ✕
                                    </button>
                                    <h3 className="text-xl font-semibold text-blue-600 mb-4">
                                      How to Upload Bulk Calls
                                    </h3>
                                    <ul className="space-y-4">
                                      <li className="flex items-start">
                                        <span className="p-3 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-semibold mr-3">
                                          1
                                        </span>
                                        <p className="text-gray-700">
                                          <strong>Run the Shell Script:</strong>{" "}
                                          Run the following commands in your
                                          local system command prompt/Terminal
                                          to generate the CSV file.
                                          <strong>
                                            (Be in the same folder where the
                                            script is downloaded)
                                          </strong>
                                          <br />{" "}
                                          <strong>
                                            <ol className="list-decimal list-inside mt-2 ml-4">
                                              <li>chmod +x bulkupload.sh</li>
                                              <li>
                                                ./bulkupload.sh (Folder path)
                                              </li>
                                            </ol>
                                          </strong>
                                        </p>
                                      </li>
                                      <li className="flex items-start">
                                        <span className=" p-3 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-semibold mr-3">
                                          2
                                        </span>
                                        <p className="text-gray-700">
                                          <strong>Get the CSV file: </strong>
                                          After the script runs and the
                                          uploading process is completed, a CSV
                                          file will be generated in the same
                                          folder.
                                        </p>
                                      </li>
                                      <li className="flex items-start">
                                        <span className=" p-3 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-semibold mr-3">
                                          3
                                        </span>
                                        <p className="text-gray-700">
                                          <strong>
                                            Verify the Details in the CSV File:
                                          </strong>
                                          Verify all the details in the CSV file
                                          before uploading the file.
                                        </p>
                                      </li>
                                      <li className="flex items-start">
                                        <span className=" p-3 inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-semibold mr-3">
                                          4
                                        </span>
                                        <p className="text-gray-700">
                                          <strong>Upload the CSV: </strong>Click
                                          the upload area, select the created
                                          CSV file, and then click Upload.
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                              {/* <a
                                href="/sample.csv"
                                download="sample.csv"
                                className="text-blue-600 hover:underline hover:text-blue-800 whitespace-nowrap"
                              >
                                📥 Download Sample CSV
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {supportingInfoPending && (
                      <div className="empty-call">Loading...</div>
                    )}

                    <div className="row">
                      <div className="col-md-12">
                        <p className="errorColor">{supportingInfoError}</p>
                        {uploadError && (
                          <p className="errorColor">{uploadError}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="border"></div>
                  <div className="popup-footer">
                    {!uploadPending && (
                      <>
                        <button
                          className="btn"
                          type="button"
                          onClick={() => {
                            toggolCallModal();
                            setEmptycall(false);
                            setDurationerror(false);
                            setBulkupload(!bulkupload);
                            setIsKnowMoreOpen(false);
                            setSelectedFileName("");
                            setSelectedfile(null);
                            setError("");
                            setUploadError(null);
                          }}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                        {/* <button className="btn" type="button" onClick={addCall}>
                          {" "}
                          Add Call
                        </button> */}
                        <button
                          className="btn Save"
                          type="button"
                          onClick={handleBulkUpload}
                          disabled={bulkLoader}
                        >
                          <span className=" flex justify-center items-center gap-4">
                            {bulkLoader && (
                              <ClipLoader color="white" size="22px" />
                            )}{" "}
                            Upload{" "}
                          </span>
                        </button>
                      </>
                    )}

                    {uploadPending && (
                      <ProgressBar
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Tooltip on top"
                        bgcolor="#271078"
                        progress={callUploadProgress}
                        height={20}
                      />
                    )}
                  </div>
                </span>
              )}
            </div>
          </div>
        </div>
      )}
      {callUploadSucess && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-50"></div>
          <div
            className="bg-white rounded-lg p-8 z-10 text-center "
            style={{ height: "320px", width: "500px" }}
          >
            <div className=" flex justify-center mt-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="currentColor"
                class="bi bi-hourglass-split spin"
                viewBox="0 0 16 16"
              >
                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
              </svg>
            </div>
            <div className=" mt-8">
              <h3>Thank you </h3>
              <p className=" font-semibold">{bulkerrormessage}</p>
              <p>Estimated Time : {estimatedTime}</p>
              <p className=" text-red-500" style={{ fontSize: "15px" }}>
                You will receive an email, once the calls are processed
              </p>
            </div>

            <button
              onClick={() => setCallUploadSucess(false)}
              className=" mt-10 px-8 py-4 bg-blue-900 text-white rounded hover:bg-orange-600 text-2xl"
            >
              Close
            </button>
          </div>
        </div>
      )}
      {newcustomer && (
        <div className="modal my-calls-popup show">
          <div className="backdrop"></div>
          <div className="modal-dialog" role="document">
            <div className="my-calls-popup-details">
              <h2>
                <div className="icon-div">
                  <div>
                    <span>
                      <img
                        src="assets/images/user-icon.png"
                        className="img-responsive"
                        alt=""
                      />
                    </span>
                  </div>
                </div>
                New Contact
              </h2>

              {!showConfirmation && (
                <div className="my-calls-form">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-col clearfix">
                        <label>ID (Optional) </label>
                        <br />
                        <input
                          type="text"
                          placeholder="Enter ID"
                          value={contactID}
                          onChange={(e) => {
                            setContactID(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-col clearfix">
                        <label>
                          First Name{" "}
                          <span style={{ color: "red", marginLeft: "0px" }}>
                            *
                          </span>
                        </label>{" "}
                        &nbsp;<br></br>
                        <select
                          className="salutationInput"
                          onChange={(e) => {
                            setSalutation(e.target.value);
                          }}
                        >
                          <option value=""></option>
                          <option value="Mr.">Mr.</option>
                          <option value="Mrs.">Mrs.</option>
                          <option value="Ms.">Ms.</option>
                        </select>
                        <input
                          className="firstNameInput"
                          type="text"
                          placeholder="Enter First Name"
                          value={firstName}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                          }}
                        />
                      </div>

                      <div className="form-col clearfix">
                        <label>Middle Name</label>
                        <input
                          type="text"
                          placeholder="Enter middle Name"
                          value={middleName}
                          onChange={(e) => {
                            setMiddleName(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-col clearfix">
                        <label>
                          Last Name{" "}
                          <span style={{ color: "red", marginLeft: "0px" }}>
                            *
                          </span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter last Name"
                          value={lastName}
                          onChange={(e) => {
                            setLastName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-col clearfix">
                        <label>
                          Suffix{" "}
                          <span style={{ color: "red", marginLeft: "0px" }}>
                            *
                          </span>{" "}
                        </label>
                        <input
                          type="text"
                          placeholder="Enter suffix"
                          value={suffix}
                          onChange={(e) => {
                            setSuffix(e.target.value);
                          }}
                        />
                      </div>

                      <div className="form-col clearfix">
                        <label>
                          Contact Number{" "}
                          <span style={{ color: "red", marginLeft: "0px" }}>
                            *
                          </span>
                        </label>

                        <PhoneInput
                          country={"eg"}
                          enableSearch={true}
                          value={contactNumber}
                          onChange={(phone) => setContactNumber(phone)}
                          placeholder="Enter contact Number"
                          inputStyle={{
                            width: "485px",
                            backgroundColor: "#e6eaed",
                            border: "none",
                            height: "44px",
                          }}
                        />
                      </div>

                      <div className="form-col clearfix">
                        <label>Reference </label>
                        <select
                          onChange={(e) => {
                            setReferenceID(e.target.value);
                          }}
                        >
                          <option value=""></option>
                          {contactList &&
                            contactList.map((contact) => (
                              <option value={contact.id}>
                                {contact.id}&nbsp;: &nbsp;{contact.first_name}
                                &nbsp;{contact.middle_name}&nbsp;
                                {contact.last_name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-col clearfix">
                        <label>Email</label>
                        <input
                          type="text"
                          placeholder="Enter email"
                          value={relation}
                          onChange={(e) => {
                            setRelation(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <p className="errorColor">{errorText}</p>
                    </div>
                  </div>
                </div>
              )}

              {showConfirmation && (
                <div className="my-calls-form">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-col clearfix">
                        <label>ID</label>
                        <br />
                        <label>
                          <b>{contactID || "="}</b>
                        </label>
                      </div>
                      <div className="form-col clearfix">
                        <label>First Name</label> <br />
                        <label>
                          <b>{salutation || "="}</b>
                        </label>{" "}
                        &nbsp;{" "}
                        <label>
                          <b>{firstName || "="}</b>
                        </label>
                      </div>
                      <div className="form-col clearfix">
                        <label>Middle Name</label>
                        <br />
                        <label>
                          <b>{middleName || "="}</b>
                        </label>
                      </div>
                      <div className="form-col clearfix">
                        <label>Last Name</label>
                        <br />
                        <label>
                          <b>{lastName || "="}</b>
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-col clearfix">
                        <label>Suffix</label>
                        <br />
                        <label>
                          <b>{suffix || "="}</b>
                        </label>
                      </div>

                      <div className="form-col clearfix">
                        <label>Contact Number</label>
                        <br />
                        <label>
                          <b>{contactNumber || "="}</b>
                        </label>
                      </div>

                      <div className="form-col clearfix">
                        <label>Reference </label>
                        <br />
                        <label>
                          <b>{referenceID || "="}</b>
                        </label>
                      </div>

                      <div className="form-col clearfix">
                        <label>Email</label>
                        <br />
                        <label>
                          <b>{relation || "="}</b>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <p className="errorColor">{errorText}</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="border"></div>
              <div className="popup-footer">
                {!isStorePending && (
                  <button
                    onClick={() => {
                      setNewcustomer(false);
                      setShowCallModal(true);
                      setShowConfirmation(false);
                      setErrorText("");
                      setContactID("");
                      setSalutation("");
                      setFirstName("");
                      setMiddleName("");
                      setLastName("");
                      setSuffix("");
                      setContactNumber("");
                      setReferenceID("");
                      setRelation("");
                    }}
                    className="btn"
                    data-dismiss="modal"
                    type="button"
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                )}
                {!showConfirmation && (
                  <button
                    className="btn Save"
                    type="button"
                    onClick={addNewContact}
                  >
                    {" "}
                    Save{" "}
                  </button>
                )}
                {showConfirmation && !isStorePending && (
                  <button
                    className="btn Save"
                    type="button"
                    onClick={confirmAddNewContact}
                  >
                    <b> Confirm </b>{" "}
                  </button>
                )}
                {showConfirmation && isStorePending && (
                  <button className="btn Save" disabled type="button">
                    <b> Storing... </b>{" "}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CallList;
